import type { UserProfileApiResponse } from '@/http/types/userProfileApiResponse';
import { useAccount, useMsal } from '@azure/msal-react';
import { useQuery } from '@tanstack/react-query';

import UserProfileService from '../../../http/UserProfileService';
import queryKeys from './queryKeys';

const useUserProfile = () => {
  const { accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const userAccountReplace = import.meta.env.VITE_HOMEACCOUNT_STRING_REPLACE || '';
  const userAccount: string =
    account?.homeAccountId.split('.')[0].replace(userAccountReplace, '') || '';

  const query = useQuery<UserProfileApiResponse>({
    queryKey: [queryKeys.userProfile, userAccount],
    queryFn: async () => {
      const res = await UserProfileService.getParticularUserProfile(userAccount);
      return res.data;
    },
    enabled: !!userAccount
  });

  return query;
};

export default useUserProfile;
